import { createEditingStyle } from 'ol/style/Style';

import { GeometryType } from 'cadenza/map/geom/geometry-type';
import { InteractionGroup } from 'cadenza/map/interactions/interaction-group';
import { SnapInteraction } from 'cadenza/map/interactions/snap-interaction';
import { convertStyle } from 'cadenza/map/convert-style';
import { CommonDrawInteraction } from 'cadenza/map/interactions/common-draw-interaction';

export class CommonDrawInteractionGroup extends InteractionGroup {

  // Optional type and featureStyle are used in the SketchLayer. AreaSearch doesn't need it.
  constructor (paletteItem, source, map,
    {
      type = paletteItem.type,
      featureStyle = convertStyle(paletteItem.style)
    } = {}
  ) {
    const drawInteraction = new CommonDrawInteraction({
      source,
      type,
      isTextModeDrawing: paletteItem.type === 'text',
      featureStyle,
      style: createEditingStyle()[GeometryType.POINT] // show only a point at the mouse cursor and no lines
    }, map, paletteItem);

    const snapInteraction = new SnapInteraction({ source });
    super(drawInteraction, snapInteraction);
    this._paletteItem = paletteItem;
  }

  getPaletteItem () {
    return this._paletteItem;
  }

}
